export default __webpack_public_path__ + "static/media/amazon-smile-big.001ebc24.png";